export class UpdateTagDefinitionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowedValues",
            "baseName": "allowedValues",
            "type": "Set<string>",
            "format": ""
        },
        {
            "name": "inheritance",
            "baseName": "inheritance",
            "type": "DataCatalogTagInheritance",
            "format": ""
        },
        {
            "name": "applicableResourceTypes",
            "baseName": "applicableResourceTypes",
            "type": "Array<DataCatalogTagResourceType>",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateTagDefinitionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
